module.exports = __webpack_public_path__ + "static/media/payoneer-dark.8d95de50.svg";